import { TFunction } from 'i18next'

const steps = (t: TFunction) => [
    {
        selector: '#holiday_date',
        content: t('date-steps'),
    },
    {
        selector: '#holiday_work_n_day',
        content: t('work_n_day-steps'),
    },
    {
        selector: '#holiday_name',
        content: t('name-steps'),
    },
    {
        selector: '#add_day',
        content: t('add_day-steps'),
    },
    {
        selector: '#create_holiday',
        content: t('create-steps'),
    },
]

export default steps
